.info-icon {
  background: var(--color-brand-blue-dark);
  border-radius: 50%;
  padding: 5px;
  width: 32px;
  height: 32px;
  margin: 0 10px 10px 0;
  display: inline-block;
  position: relative;

  :global(.icon) {
    position: absolute;
    fill: #fff;
    top: 8px;
    left: 8px;
    border-radius: 0;
    width: 16px;
    height: 16px;
  }
}